import BHowAnalyse from './BHowAnalyse'

export default BHowAnalyse
